import {getPurposesForFolderSection} from 'archive/ArchivePurposesUtil';
import {FolderSection} from 'constants/FolderConstants';
import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FilterOption} from 'search/filters/base/FilterComponents';
import {FilterKey} from 'search/SearchConstants';

export const ANY_LINK_FILTER: FilterOption = {filterKey: FilterKey.ANY_LINK_SCHEMA_FIELD};

export const GENERAL_FILTER_OPTIONS_WITHOUT_SCHEMA_FIELD: Array<FilterOption> = [
  {filterKey: FilterKey.NAMES},
  {filterKey: FilterKey.CREATED_AT},
  {filterKey: FilterKey.MODIFIED_AT},
  {filterKey: FilterKey.API_IDS},
  {filterKey: FilterKey.CREATOR},
  {
    filterKey: FilterKey.ARCHIVE_PURPOSES,
    // TODO(workflows): extract archive purposes from "notebook" namespace in case there is any drift
    // between the two
    extraProps: {archivePurposes: getPurposesForFolderSection(FolderSection.NOTEBOOK)},
  },
];

export const PROCESS_FILTER_OPTIONS: Array<FilterOption> = [
  {filterKey: FilterKey.PROCESS_STATUS},
  {filterKey: FilterKey.PROCESS_WATCHER},
  {filterKey: FilterKey.PROCESS_EXECUTION_TYPE},
];

export const PROCESS_TASK_FILTER_OPTIONS: Array<FilterOption> = [
  {filterKey: FilterKey.PROCESS},
  {filterKey: FilterKey.PROCESS_TASK_STATUS},
  {filterKey: FilterKey.PROCESS_TASK_ASSIGNEE},
  {filterKey: FilterKey.PROCESS_TASK_EXECUTION_ORIGIN_ENTRY},
  {filterKey: FilterKey.PROCESS_TASK_SCHEDULED_ON_DATE},
  {filterKey: FilterKey.PROCESS_TASK_RESPONSIBLE_PARTIES},
];

export const PROCESS_OUTPUT_FILTER_OPTIONS: Array<FilterOption> = [
  {filterKey: FilterKey.CREATION_ORIGIN_ENTRY},
  {filterKey: FilterKey.PROCESS_TASK},
];

export const PROCESS_FLOWCHART_FILTER_OPTIONS: Array<FilterOption> = [
  {filterKey: FilterKey.ROOT_PROCESS},
  {
    filterKey: FilterKey.ROOT_PROCESS_TASK_SCHEMA,
    extraProps: {schemaExecutionTypes: [ProcessExecutionType.FLOWCHART]},
  },
  {filterKey: FilterKey.ROOT_PROCESS_CREATOR},
  {filterKey: FilterKey.ROOT_PROCESS_WATCHER},
  {
    filterKey: FilterKey.PROCESS_TASK_HAS_FAILED_MAPPINGS,
  },
];
